import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import logo from '../../assets/alkemy/logo.png';
import logoutIcon from '../../assets/header/logout-icon.svg';
import { t } from '../../i18n/i18n';
import { SetAuthenticated } from '../../redux/actions/authActions';
import { Window } from '../../utils/window';
import './Header.scss';
import { HOME } from '../../constants/routes';

const PublicHeader = ({ redirectHome }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogout = () => {
    if (Window()) {
      localStorage.clear();
      dispatch(SetAuthenticated(false));
      history.push(HOME);
    }
  };

  return (
    <header className="header d-flex align-items-center justify-content-between flex-wrap px-xs-2 px-1 mb-3">
      <div className="d-flex align-items-center flex-wrap py-1">
        <Link to={redirectHome}>
          <img src={logo} className="logo mr-sm-4" alt={t('HEADER_LOGO')} />
        </Link>
        <div className="d-none d-md-inline header-vertical-line mr-sm-4" />
      </div>

      <div className="d-flex py-1 align-self-center">
        <button
          type="button"
          className="btn btn-link d-flex align-items-center p-2"
          onClick={handleLogout}
          title={t('BUTTON_LOGOUT')}
        >
          <img
            src={logoutIcon}
            alt={t('BUTTON_LOGOUT')}
            className="mr-2"
            style={{ width: '20px', height: '20px' }}
          />
          <span className="d-flex d-sm-inline text-xs text-dark font-weight-bold">
            {t('BUTTON_LOGOUT')}
          </span>
        </button>
      </div>
    </header>
  );
};

export default PublicHeader;
